import { useContext } from 'react'
import { randomCode } from '../utils/utils'
import * as uuid from 'uuid'
import { ErrorContexts } from '../contexts/ErrorContext'
import CouponsService, { Coupon } from '../services/coupons-service'

const useCoupons = () => {
  const { setError } = useContext(ErrorContexts)

  const availableAmounts: Record<number, string> = {
    1: '8436013922138',
    5: '8436013922855',
    10: '8436013922022',
    20: '8436013922039',
    50: '8436013922046',
    100: '8436013922053'
  }

  const getRechargeCodeData = (amount: number): Coupon => {
    if (!availableAmounts[amount]) {
      throw new Error(`Amount ${amount} not valid`)
    }

    const code = randomCode(8, true, false, true, '')
    const id = uuid.v4()

    return {
      productType: availableAmounts[amount],
      code,
      id,
      merchantId: 'admin-front',
      amount
    }
  }

  const createCoupon = async (amount: number) => {
    try {
      const codeData = getRechargeCodeData(amount)
      await CouponsService.create(codeData)
      return codeData
    } catch (err) {
      console.error(err)
      setError(err)
      throw err
    }
  }

  return { createCoupon, availableAmounts }
}

export default useCoupons
